<div class="header">
  <h3>Inspection Code Setup</h3>
</div>

<div class="row">
  <div class="col-md-2">
    <div class="mb-3">
      <a [routerLink]="['../inspection-engagement']" [queryParams]="{ id: 'new' }" class="btn btn-primary text-nowrap">
        <i class="fa fa-plus"></i>
        Create
      </a>
    </div>
  </div>
</div>

<grid-pager [actionName]="'../inspection-engagements'" [page]="page" [limit]="limit" [pageCount]="pageCount" [limits]="pageLimitOptions"></grid-pager>

<div class="">
  <table id="inspection-engagement-grid" class="table table-striped table-align-middle my-2">
    <thead>
      <tr class="headers-row">
        <th class="col-action"></th>
        <th style="width: 8rem;">Code</th>
        <th style="width: 25%;">Client</th>
        <th style="width: 14rem;">Office</th>
        <th style="width: 6rem;">Region</th>
        <th style="width: 6rem;">Year</th>
      </tr>
      <tr class="filters-row">
        <td>
          <button type="button" class="btn btn-sm btn-block btn-secondary text-nowrap" (click)="clearFilters()">
            <i class="fa fa-times"></i>
            Clear
          </button>
        </td>
        <td><input type="text" class="form-control form-control-sm" placeholder="Filter by..." [(ngModel)]="codeFilter" /></td>
        <td><input type="text" class="form-control form-control-sm" placeholder="Filter by..." [(ngModel)]="clientFilter" /></td>
        <td><input type="text" class="form-control form-control-sm" placeholder="Filter by..." [(ngModel)]="officeFilter" /></td>
        <td><input type="text" class="form-control form-control-sm" placeholder="Filter by..." [(ngModel)]="regionFilter" /></td>
        <td><input type="text" class="form-control form-control-sm" placeholder="Filter by..." [(ngModel)]="yearFilter" /></td>
      </tr>
    </thead>
    <tbody>
      @if (pagedEngagements.length == 0) {
        <tr>
          <td colspan="6">
            @if (!isLoading) {
              <span class="d-block p-2 text-center">
                <i class="fa fa-ban text-danger"></i>
                No data to display&hellip;
              </span>
            }
            @if (isLoading) {
              <span class="d-block p-2 text-center">
                <i class="fa fa-spin fa-refresh text-primary"></i> Please wait while we load your inspection engagements&hellip;
              </span>
            }
          </td>
        </tr>
      }
      @for (engagement of pagedEngagements; track engagement) {
        <tr>
          <td>
            <div class="btn-group btn-group-sm">
              <a class="btn btn-primary mr-1" [routerLink]="['../inspection-engagement']" [queryParams]="{ id: engagement.id }">
                <i class="fa fa-pencil"></i>
                <span class="sr-only">Edit</span>
              </a>
              <button type="button" class="btn btn-secondary" (click)="destroyEngagement(engagement)">
                <i class="fa fa-trash"></i>
                <span class="sr-only">Remove</span>
              </button>
            </div>
          </td>
          <td>{{engagement.code}}</td>
          <td>{{engagement.client ? engagement.client.name : ''}}</td>
          <td>{{engagement.office ? (engagement.office.id + ' - ' + engagement.office.name) : ''}}</td>
          <td>{{engagement.regionCode}}</td>
          <td class="text-right">{{engagement.inspectionYear}}</td>
        </tr>
      }
    </tbody>
  </table>
</div>

<grid-pager [actionName]="'../inspection-engagements'" [page]="page" [limit]="limit" [pageCount]="pageCount" [limits]="pageLimitOptions"></grid-pager>
